export default "__VITE_ASSET__CLF7$9ku__"